import React, { Component } from 'react';
import FormWrapper from '../../containers/Forms/FormWrapper';
import FormUserProfile from '../../containers/Forms/FormUserProfile';
import { entityNames } from '../../config/constants';

class CreateProfile extends Component {
  componentDidMount() {
    const { fetchReset } = this.props;
    if (fetchReset) {
      fetchReset(entityNames.CREATE_USER);
    }
  }

  render() {
    return (
      <div className="auth-page">
        <div className="auth-logo" />
        <div className="auth-card">
          <h1>Create Profile</h1>

          <FormWrapper
            entityName={entityNames.CREATE_USER}
            entity={[
              'name',
              'displayName',
              'contactInfo',
              'password',
              'imageUUID',
            ]}
            onSubmit={this.onCreateUser}
            noValidation={true}
          >
            <FormUserProfile />
          </FormWrapper>

          <div className="auth-disclaimer">
            {this.props.t('userProfile:createProfileDisclaimer')}
          </div>
        </div>
      </div>
    );
  }

  onCreateUser = (data, entityName) => {
    this.props.createUser(data, entityName);
  };
}

export default CreateProfile;
